import toast from 'components/Toast/dispatch';
import React, { FC, useRef } from 'react';
import Button from '../../../../../../Button';
import QuoteServices from '../../../../../../../../../../services/quote.service';
import './styles.scss';

interface IMinProfitabilityModal {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    supplierProductcode: string,
    customerCode: string,
    distributionCenter: any,
    setMinimumProfitability: React.Dispatch<React.SetStateAction<number>>,
    setMinProfitabilityMessage: any
}

const MinProfitabilityModal: FC<any> = ({ 
    open, 
    setOpen, 
    supplierProductcode, 
    customerCode, 
    distributionCenter, 
    setMinimumProfitability,
    setMinProfitabilityMessage
}: IMinProfitabilityModal) => {

    const modal: any = useRef(null);

    const closeOpen = (e: any) => {
        if (modal?.current && !modal?.current.contains(e.target)) {
            handleOpenClose()
        }
    }

    const handleOpenClose = () => {
        if (open === false) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    };

    const handleModalClose = () => {
        document.addEventListener("mousedown", closeOpen);
    }
    handleModalClose();

    const handleButtonGetItemStock = async () => {
        const resultMapping = await new QuoteServices().getItemStock(
          supplierProductcode,
          customerCode,
        )
        if (resultMapping) {
          resultMapping.map((item: any) => {
            if (item.local === distributionCenter) {
                setMinProfitabilityMessage(`Rent. mín.: ${item.minimumProfitability}%`)
                setMinimumProfitability(item.minimumProfitability);
            }
            setOpen(false)
          });
        } else {
          toast.error(
            "Não foi possível atualizar rentabilidade mínima. Por favor, tente novamente."
          );
        }
      };

    return (
        <>
            <div className='modalContainer' ref={modal}>
                <div className='blockedPrice'>
                    <h1 className='modalTitle'>Renta Mínima Bloqueada</h1>
                    <p className='modalText'>Para aplicar valores abaixo da <br /> renta mínima, solicite o ajuste <br /> do novo valor.</p>
                </div>
                <div className='divisor'>
                    <hr />
                </div>
                <div className='applyPrice'>
                    <p className='modalText'>Após a renta mínima ajustada, <br /> clique para atualizar: </p>
                    <Button onClick={handleButtonGetItemStock} label={'Atualizar nova renta mínima'} className='applyPriceButton'></Button>
                </div>
                <div className='lockPiece'></div>
            </div>
        </>
    );
}
export default MinProfitabilityModal;